import i18n from '~/locales/i18n';

i18n.addResourceBundle('en', 'app', {
  featureListingPageTitle: 'Feature Listing',
  featureListingTitle:
    'Choose the right feature for your listing and get more leads.',
  featureBestValue: 'Best Value',
  featureStatCalls: 'Calls',
  featureStatViews: 'Views',
  featureStatImpressions: 'Impressions',
  featureMultiplierValue: '{{value}}X',
  featureCreditDuration: '{{credit}} Points for <tag>({{days}} Days)</tag>',
  featureAmountDuration: '{{credit}} EGP for <tag>({{days}} Days)</tag>',
  featureWithType: 'Feature with {{name}}',
  featureConfirmQuestion: 'Are you sure you want to feature with {{name}}?',
  featureConfirmDescription:
    '{{credit}} points will be deducted to feature this listing for {{days}} days',
  featureConfirmAction: 'Feature',
  featureNoCreditQuestion:
    'You do not have enough credit to feature with {{name}}?',
  featureErrorTitle: 'An unexpected error occurred',
  featureErrorDescription: 'Please try again',
  featurePaymentDetails: 'Payment Details',
  featurePaymentSummary: 'Payment Summary',
  featurePrice: 'Price',
});
